import React from 'react';
import { formatToBSDisplay, formatToBSDate } from '../utils/nepaliDateUtils';

const BSDateDisplay = ({ date, format = 'display', showLabel = false }) => {
  if (!date) return <span>-</span>;

  const formattedDate = format === 'display' 
    ? formatToBSDisplay(date) 
    : formatToBSDate(date);

  return (
    <span>
      {showLabel && <span style={{ fontSize: '0.8em', color: '#666' }}>BS: </span>}
      {formattedDate}
    </span>
  );
};

export default BSDateDisplay;
